import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Page from '../../../components/Page';
import ChannelCapabilitiesGrid from '../../../components/ChannelCapabilitiesGrid';
import { CHANNELS, CAPABILITIES } from '../../../data/channelCapabilitiesV1';
import { ApiVersion } from '../../../data/versions';

export default class ChannelCapabilities extends Component {
    static title = 'Channel Capabilities v1';
    static section = 'guide';
    static className = 'channel-capabilities-grid-page';

    static propTypes = {
        pathContext: PropTypes.object.isRequired,
        location: PropTypes.object,
    };

    render() {
        return (
            <Page
                {...this.props}
                className={ChannelCapabilities.className}
                title={ChannelCapabilities.title}
                section={ChannelCapabilities.section}
            >
                <div className="page-content">
                    <ChannelCapabilitiesGrid
                        channels={CHANNELS}
                        capabilities={CAPABILITIES}
                        version={ApiVersion['v1.1']}
                    />
                </div>
            </Page>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/guide/v1/channel-capabilities.jsx